import { Component, inject, input, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { combineLatest, filter, map, of, startWith, switchMap } from 'rxjs';
import { ReportsService } from 'src/app/reports/reports.service';
import { AppService as AppService } from 'src/app/services/app.service';
import { CapitalVolumeGraph } from './CapitalVolumeGraph';
import { CaseVolumeGraph } from './CaseVolumeGraph';
import { GraphBase } from './GraphBase';
import { ChartModule } from 'primeng/chart';
import { CommonModule } from '@angular/common';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss'],
  imports: [CommonModule, TranslateModule, ChartModule]
})

export class GraphComponent {
  #reportsService = inject(ReportsService);
  #translate = inject(TranslateService);
  #application = inject(AppService);

  @Input() name: 'CaseVolume' | 'CapitalVolume';
  nameSig = input<'CaseVolume' | 'CapitalVolume' | null>();

  graph = toSignal(combineLatest([
    this.#application.customerNumber$, 
    this.#translate.onLangChange.pipe(startWith(null)),
    toObservable(this.nameSig).pipe(
      filter((name): name is 'CaseVolume' | 'CapitalVolume' => name !== null)
    )])
    .pipe(switchMap(([customerNumber, _, name]) => {
      let graph: GraphBase = null;
      switch (this.name) {
        case 'CaseVolume':
          graph = new CaseVolumeGraph(this.#reportsService, this.#translate);
          break;
        case 'CapitalVolume':
          graph = new CapitalVolumeGraph(this.#reportsService, this.#translate);
          break;
        default: graph = null; break;
      }
      return graph ? graph.get(customerNumber) : of(null);
    })));

  title = toSignal(this.#translate.onLangChange.pipe(
    startWith(null),
    map(_ => this.#translate.instant(`Graphs.${this.name}.Title`)
    )));
}

export interface IAppGraphModel {
  data: any;
  type: 'line' | 'bar';
  options: any;
}

